jQuery(function ($) {
    function flyOutMenu() {
        $(".hamburger_icon").on("click", function () {
            $(this).toggleClass("close_icon");
            $(".flyout_menu").toggleClass("show_menu");
        });

        $(".menu_item a").on("click", function () {
            $(".flyout_menu").removeClass("show_menu");
            $(".hamburger_icon").removeClass("close_icon");
        });

        $(window).on("load", function () {
            $(".flyout_menu").removeClass("show_menu");
            $(".hamburger_icon").removeClass("close_icon");
        });
    }

    function searchToggle() {
        $(".search_icon").on("click", function () {
            $(".search_box").addClass("show_search");
        });
        $(".close_icon").on("click", function () {
            $(".search_box").removeClass("show_search");
        });
    }

    function homeSlider() {
        $(".home__slider").slick({
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick",
                },
                {
                    breakpoint: 767,
                    settings: {
                        infinite: false,
                        slidesToShow: 1.25,
                        slidesToScroll: 2,
                        arrows: true,
                        prevArrow:
                            '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="5.718" height="10" viewBox="0 0 5.718 10"><path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M11.189,15.241l3.781-3.784a.712.712,0,0,1,1.009,0,.721.721,0,0,1,0,1.012L11.7,16.756a.713.713,0,0,1-.985.021L6.4,12.472a.715.715,0,0,1,1.009-1.012Z" transform="translate(16.964 -6.188) rotate(90)" fill="#282828"/></svg></button>',
                        nextArrow:
                            '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="5.718" height="10" viewBox="0 0 5.718 10"><path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M5,1.724,8.783,5.508a.712.712,0,0,0,1.009,0,.721.721,0,0,0,0-1.012L5.508.208A.713.713,0,0,0,4.523.187L.208,4.493A.715.715,0,1,0,1.218,5.5Z" transform="translate(5.718) rotate(90)" fill="#282828"/></svg></button>',
                    },
                },
            ],
        });
    }

    function newsMatch() {
        $(".news_block .news_block-content h4").matchHeight();
        $(".news_block .news_block-content p").matchHeight();
    }

    function sidebarAppend() {
        if ($(window).width() < 991) {
            $(".blockL_sidebarR-right").prependTo(".home-ad");
        }
    }

    function rightNavAppend() {
        if ($(window).width() < 992) {
            $(".header_right ul")
                .appendTo(".flyout_menu")
                .addClass("login-nav");
        }
    }

    function navToggleResponsive() {
        if ($(window).width() < 768) {
            $(".nav-head").on("click", function () {
                $(this).siblings("ul").slideToggle();
                $(this).toggleClass("nav-up");
            });
        }
    }

    function childMenuHover() {
        $(".menu-item-has-children").hover(
            function () {
                $(this).addClass("show_child_menu");
            },
            function () {
                $(this).removeClass("show_child_menu");
            }
        );
    }
    function otherNewsCarousel() {
        $(".cp-other-news-carousel").slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow:
                "<button type='button' class='slick-prev pull-left'><svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='20' cy='20' r='19.5' transform='matrix(-1 0 0 1 40 0)' stroke='#231F20' stroke-opacity='0.3'/><path d='M28 19.5565V21.4435H16.0274L20.2839 25.7L19.0048 27L12.4839 20.479L19.0048 14L20.2839 15.3L16.0065 19.5565H28Z' fill='#231F20'/></svg></button>",
            nextArrow:
                "<button type='button' class='slick-next pull-right'><svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='20' cy='20' r='19.5' stroke='#231F20' stroke-opacity='0.3'/><path d='M12 19.5565V21.4435H23.9726L19.7161 25.7L20.9952 27L27.5161 20.479L20.9952 14L19.7161 15.3L23.9935 19.5565H12Z' fill='#231F20'/></svg></button>",
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
    $(".packages_block").matchHeight();
    $(".packages_block ul").matchHeight();
    $(".offer_block h3").matchHeight();
    $(".offer_block p").matchHeight();
    $(".testimonial").matchHeight();

    flyOutMenu();
    // searchToggle();
    // homeSlider();
    newsMatch();
    sidebarAppend();
    rightNavAppend();
    navToggleResponsive();
    childMenuHover();
    otherNewsCarousel();

    $(window).on("resize", function () {
        // homeSlider();
        sidebarAppend();
        rightNavAppend();
        $(".packages_block").matchHeight();
        $(".packages_block ul").matchHeight();
    });
});

function initStickyElement() {
    const secondary = document.querySelector(
        "body.page-template-template-construction-pro #secondary"
    );

    if (!secondary) {
        return; // Exit if the element doesn't exist
    }

    const sticky = secondary.offsetTop;
    const offset = 0; // Adjust the sticky offset if needed
    const scrollThreshold = 300; // Trigger sticky after 200px of scrolling

    function makeSticky() {
        if (window.scrollY >= scrollThreshold) {
            if (window.scrollY >= sticky - offset) {
                secondary.classList.add("sticky");
            } else {
                secondary.classList.remove("sticky");
            }
        } else {
            secondary.classList.remove("sticky"); // Remove sticky if scroll is less than threshold
        }
    }

    window.onscroll = function () {
        makeSticky();
    };
}

initStickyElement();
